import index from './index.json';

const surahModules = import.meta.glob('./surahs/*.json', { import: 'default' });

export const surahs = [...index.surahs].reverse();
export const surahIndex = index;

export function getSurahByRoute(routePart) {
  return surahs.find((surah) => `${surah.number}-${surah.slug}` === routePart);
}

export function getSurahByNumber(number) {
  return surahs.find((surah) => surah.number === Number(number));
}

export async function loadSurahByRoute(routePart) {
  const meta = getSurahByRoute(routePart);
  if (!meta) return null;
  const filename = `${String(meta.number).padStart(3, '0')}-${meta.slug}.json`;
  const entry = Object.entries(surahModules).find(([modulePath]) => modulePath.endsWith(filename));
  if (!entry) throw new Error(`Geen lokaal databestand gevonden voor ${routePart}`);
  return entry[1]();
}

export async function loadQuizData() {
  const module = await import('./quiz.json');
  return module.default;
}
